import { render, staticRenderFns } from "./NoticeImg.vue?vue&type=template&id=36f03a8c&scoped=true&lang=pug&"
import script from "./NoticeImg.vue?vue&type=script&lang=ts&"
export * from "./NoticeImg.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeImg.vue?vue&type=style&index=0&id=36f03a8c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f03a8c",
  null
  
)

export default component.exports